import { render, staticRenderFns } from "./AssetBadge.vue?vue&type=template&id=813e7ebc"
import script from "./AssetBadge.vue?vue&type=script&lang=js"
export * from "./AssetBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports